import React, { useRef, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import LoadingPage from '../../components/Loading'
import Typography from '@mui/material/Typography';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { IoReceiptSharp } from 'react-icons/io5';
import { GiWashingMachine, GiFoldedPaper } from 'react-icons/gi';
import { MdLocalLaundryService, MdDeliveryDining, MdLocationOn, MdPayment, MdStore, MdHourglassEmpty, MdOutbox, MdCancel, MdContentCopy, MdDirections, MdEdit } from 'react-icons/md';
import { AiOutlineFileDone } from 'react-icons/ai';
import { FaLayerGroup } from 'react-icons/fa';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';
import EditStatusOrderModal, { } from './EditStatusOrderModal'
import { posWashing, dashboardJobStatus, wdfDeleteStatus } from './hook/usePosApi'
import { userNameHandler, roleHandler } from '../../util/local-storage';
import { getCustomerAddressByDeliveryID, getLocationDetail, updateTrackingStep } from '../Report/utils/api-action';
import configApi from '../../config';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import OrderImgUploadModal from '../../components/OrderImgUploadModal';
import SwapOrderBranchModal from './SwapOrderBranchModal';
import UpdateSlipModal from './UpdateSlipModal';
import { Box, StepButton, TextField, Modal } from '@mui/material';




const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const StatusOrderModal: React.FC = (props) => {


    const userloginName = userNameHandler.get();
    const userRole = roleHandler.get();
    const [display, setDisplay] = useState(props);
    const [btnSubmit, setBtnSubmit] = useState(false);

    const [steps, setSteps] = useState([]);
    const [jobDesc, setJobDesc] = useState([]);
    const [serviceDate, setServiceDate] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [locationCode, setLocationCode] = useState("");
    const [orderStatus, setLocationName] = useState("");
    const [currentValue, setCurrentValue] = useState(0);

    const [isEditStatusModal, setEditStatusModal] = useState(0);
    const [orderDetail, setOrderDetail] = useState(null);


    const [loadingPageFlag, setLoadingPageFlag] = useState(0);
    const [notifyMessage, setNotifyMessage] = useState("");
    const [typeNotify, setTypeNotify] = useState('');
    const [openNotify, setNotify] = useState(false);
    const [rejectRemark, setRejectRemark] = useState("");
    const eRemark = useRef();
    const [dataOrder, setDataOrder] = useState({});

    const [chgLLogs, setChgLLogs] = useState([]);
    const [isSwapOrderBranch, setSwapOrderBranch] = useState(false)
    const [isUpdateSlipModal, setUpdateSlipModal] = useState(false)
    const [showFullPreview, setShowFullPreview] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [cancelStatusCode, setCancelStatusCode] = useState('');
    const [remark, setRemark] = useState("");
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [cancelText, setCancelText] = useState('');
    const [addressData, setAddressData] = useState([]);
    const [branchInfo, setBranchInfo] = useState(null);
    const [loadingAddress, setLoadingAddress] = useState(false);
    const [copiedKey, setCopiedKey] = useState(null);
    const [previewImg, setPreviewImg] = useState(null);
    const [localOrderImg, setLocalOrderImg] = useState(null);
    const [localPupImg, setLocalPupImg] = useState(null);
    const [localDlvdImg, setLocalDlvdImg] = useState(null);
    const [localPickupRef, setLocalPickupRef] = useState(null);
    const [localDeliveryRef, setLocalDeliveryRef] = useState(null);
    const [editPupRef, setEditPupRef] = useState(false);
    const [editPupRefVal, setEditPupRefVal] = useState('');
    const [savingPupRef, setSavingPupRef] = useState(false);
    const [editDlvdRef, setEditDlvdRef] = useState(false);
    const [editDlvdRefVal, setEditDlvdRefVal] = useState('');
    const [savingDlvdRef, setSavingDlvdRef] = useState(false);
    const [imgUploadOpen, setImgUploadOpen] = useState(false);
    const [imgUploadType, setImgUploadType] = useState('PUP');

    const toImgSrc = (p) => {
        if (!p) return p;
        if (p.startsWith('data:') || p.startsWith('http')) return p;
        // raw base64 fallback (S3 upload failure) — JPEG, PNG, GIF, WebP signatures
        if (p.startsWith('/9j/') || p.startsWith('iVBOR') || p.startsWith('R0lGO') || p.startsWith('UklGR')) {
            return `data:image/jpeg;base64,${p}`;
        }
        return `${configApi.URL_API}File/${p}`;
    };
    const isGrabOrder = props?.isGrabOrder;
    const isPaid = props?.isPaid;
    const canGrabCancel =
    isGrabOrder &&
    dataOrder?.order_status === "DROP" &&
    String(dataOrder?.remark ?? "")
        .trim()
        .toLowerCase()
        .startsWith("delivery grab;");
    const canGrabUpload = isGrabOrder && isPaid !== "Y";

    


    const handleThumbnailClick = () => {
        setShowFullPreview(true);
    };

    const handleCloseFullPreview = () => {
        setShowFullPreview(false);
    };

    const handleClose = (event, reason) => {

        if (reason && reason === "escapeKeyDown") {
            setShowFullPreview(false);
        }

        if (reason && reason == "backdropClick" && "escapeKeyDown") {
            return;
        }

        if (props.onClose != null) {
            props.onClose(false);
        }
        setDisplay({ ...props, isDisplay: false });
    };



    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleNotify = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setNotify(true);
    };


    const onSubmit = (e) => {
        e.preventDefault();
        setBtnSubmit(true);
        let remark = eRemark.current.value;

        if (remark == '') {
            setNotifyMessage('กรุณาระบุเหตุผล');
            setTypeNotify('error')
            handleNotify();
            setBtnSubmit(false);
        }
        else {
            var body = {
                "service_No": props.orderNo,
                "service_Type": "WDF",
                "status": "REJ",
                "userLogin": userloginName,
                "remark": eRemark.current.value
            };



            posWashing(body).then(function (response) {
                setNotifyMessage('บันทึกสำเร็จ');
                setTypeNotify('success');
                handleNotify();
                handleClose();
                window.location.reload();
            }).catch(function () {
                setNotifyMessage('บันทึกไม่สำเร็จ กรุณาลองอีกครั้ง');
                setTypeNotify('error')
                handleNotify();
                setBtnSubmit(false);
            });
        }

    };


    const handleCloseDialog = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setNotify(false);
    };

    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
        },
    }));

    // step 
    // const steps = ['Select campaign settings', 'Create an ad group', 'Create an ad', '', ''];

    function ColorlibStepIcon(props) {
        const { active, completed, className } = props;
        const statusCode = jobDesc[props.icon - 1]?.status_code;
        const statusIconMap = {
            'NEW':   <MdHourglassEmpty />,
            'PMT':   <MdPayment />,
            'PMT-D': <MdOutbox />,
            'DROP':  <MdStore />,
            'DDROP': <MdStore />,
            'PUP':   <MdDeliveryDining />,
            'RCV':   <IoReceiptSharp />,
            'WASH':  <GiWashingMachine />,
            'DRY':   <MdLocalLaundryService />,
            'FOLD':  <FaLayerGroup />,
            'DLVD':  <MdDeliveryDining />,
            'POD':   <AiOutlineFileDone />,
            'REJ':   <MdCancel />,
        };
        return (
            <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
                {statusIconMap[statusCode] ?? <AiOutlineFileDone />}
            </ColorlibStepIconRoot>
        );
    }
    const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#F5F5F5',
        zIndex: 1,
        color: '#C5CAE9',
        width: 70,
        height: 70,
        display: 'flex',
        // fontsize: 40,
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        ...(ownerState.active && !ownerState.completed && {
            backgroundColor: '#fff',
            border: '2px dashed #303F9F',
            color: '#303F9F',
        }),
        ...(ownerState.completed && {
            backgroundColor: '#fff',
            border: '4px solid #303F9F',
            boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            color: '#303F9F',
        }),
    }));


    // end step 

    // step 

    const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: 22,
        },
        [`&.${stepConnectorClasses.active}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                // backgroundImage:
                //     'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
                backgroundColor: "#303F9F"
            },
        },
        [`&.${stepConnectorClasses.completed}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                // backgroundImage:
                //     'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
                backgroundColor: "#303F9F"
            },
        },
        [`& .${stepConnectorClasses.line}`]: {
            height: 3,
            border: 1,

            backgroundColor:
                theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
            borderRadius: 1,
        },
    }));

    const boxStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: '16px', // Add border radius here
    };

    const openModal = () => {
        setError(false)
        setRemark('');
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleRemarkChange = (event) => {
        const value = event.target.value;
        setRemark(value);

        // Validation logic
        if (value.trim() === '') {
            setError(true);
            setErrorMessage('กรุณากรอกหมายเหตุ');
        } else {
            setError(false);
            setErrorMessage('');
        }
    };

    const handleSubmit = () => {
        // Make your API call here
        if (remark.trim() === '') {
            setError(true);
            setErrorMessage('กรุณากรอกหมายเหตุ');
        } else {
            setError(false);
            setErrorMessage('');

            const body = {
                remark: remark,
                ServiceNo: dataOrder?.order_no,
                Status: cancelStatusCode || dataOrder?.order_status,
                UpdatedBy: userloginName
            }
            wdfDeleteStatus(body).then(function (response) {
                // console.log(response?.data?.code == 200)
                //console.log('response?.data', response?.data);
                if (response?.data?.code == 200) {
                    setNotifyMessage('ยกเลิกสำเร็จ');
                    setTypeNotify('success');
                    handleNotify();
                    onSearchTracking();
                    props.onSuccess();
                }
                else {
                    setNotifyMessage(response?.data?.description);
                    setTypeNotify('error')
                    handleNotify();
                    setBtnSubmit(false);
                }

            })
            // ).catch(function () {
            //     setNotifyMessage('ยกเลิกไม่สำเร็จ กรุณาลองอีกครั้ง');
            //     setTypeNotify('error')
            //     handleNotify();
            //     setBtnSubmit(false);
            // });
            // Proceed with form submission (e.g., send data to server)
            // console.log(body);
            closeModal();
        }
    };


    //end step  

    useEffect(() => {

        if (props.isDisplay) {
            setLoadingPageFlag(0);
            onSearchTracking();
            fetchAddress();
            setDisplay(props);
            setBtnSubmit(false);
            setLocalOrderImg(props.orderImg ?? null);
            setLocalPupImg(props.pupImg ?? null);
            setLocalDlvdImg(props.dlvdImg ?? null);
            setLocalPickupRef(props.pickupRef ?? null);
            setLocalDeliveryRef(props.deliveryRef ?? null);
            setEditPupRef(false); setEditDlvdRef(false);
            setEditPupRefVal(''); setEditDlvdRefVal('');
        }
        else {

        }

    }, [props.isDisplay]);

    const onEditStatus = (order, v) => {
        setOrderDetail(v);
        setEditStatusModal(true);
    }

    const onSwapOrder = (order, v) => {
        setOrderDetail(v);
        setSwapOrderBranch(true);
    }

    const onUpdateSlip = (order, v) => {
        setOrderDetail(v);
        setUpdateSlipModal(true);
    }

    const onSearchTracking = () => {
        var loc = {
            order_no: props.orderNo,
            order_type: 'WDF'

        };
        setLoadingPageFlag(1);

        (async function () {

            dashboardJobStatus(loc).then(function (response) {
                setLoadingPageFlag(2);
                if (response.code === 401) {
                    localStorage.clear();
                } else {
                    let objContent = response?.data?.content;
                    if (objContent != undefined) {
                        setDataOrder(objContent);

                        var jobs = objContent.jobs;
                        var opl = jobs.map(i => i?.desc ?? "");
                        setSteps(opl);
                        setJobDesc(jobs);
                        setChgLLogs(objContent.chg_l_logs ?? []);
                        setServiceDate(objContent?.service_date);
                        setLocationCode(objContent?.location_code);
                        setCustomerName(objContent?.cust_name);
                        setPhoneNo(objContent?.cust_tel);
                        if (objContent.active != undefined) {
                            setCurrentValue(objContent.active);
                        }
                    } else {

                    }
                }
            });
        })()
    };

    const _noWashTypes = ['NDF', 'NDH', 'NNF', 'NNH'];
    const _noDryTypes  = ['NNF', 'NNH'];
    const _isAbsentStep = (j) => {
        const svc = dataOrder?.service_type;
        return (_noWashTypes.includes(svc) && jobDesc[j]?.status_code === 'WASH') ||
               (_noDryTypes.includes(svc)  && jobDesc[j]?.status_code === 'DRY');
    };
    const _isStepDone = (j) => jobDesc[j]?.status_date != null && jobDesc[j]?.deleted_by == null;
    const _isStepClickable = (idex) => {
        if (_isStepDone(idex)) return false;                          // already done → can't re-do
        if (idex === 0) return true;                                   // first step: clickable if not done (covers cancelled too)
        for (let i = idex - 1; i >= 0; i--) {
            if (_isAbsentStep(i)) continue;
            return _isStepDone(i);                                    // nearest non-absent prev must be done
        }
        return false;
    };

    const savePupRef = async () => {
        if (!editPupRefVal.trim()) return;
        setSavingPupRef(true);
        const newUrl = editPupRefVal.trim();
        const res = await updateTrackingStep({ order_no: props.orderNo, status_code: 'PUP', grab_url: newUrl });
        if (res?.data?.code === 200) {
            setLocalPickupRef(newUrl);
            setEditPupRef(false);
            setNotifyMessage('บันทึก Grab URL สำเร็จ'); setTypeNotify('success'); handleNotify();
        } else { setNotifyMessage('บันทึก Grab URL ไม่สำเร็จ'); setTypeNotify('error'); handleNotify(); }
        setSavingPupRef(false);
    };

    const saveDlvdRef = async () => {
        if (!editDlvdRefVal.trim()) return;
        setSavingDlvdRef(true);
        const newUrl = editDlvdRefVal.trim();
        const res = await updateTrackingStep({ order_no: props.orderNo, status_code: 'DLVD', grab_url: newUrl });
        if (res?.data?.code === 200) {
            setLocalDeliveryRef(newUrl);
            setEditDlvdRef(false);
            setNotifyMessage('บันทึก Grab URL สำเร็จ'); setTypeNotify('success'); handleNotify();
        } else { setNotifyMessage('บันทึก Grab URL ไม่สำเร็จ'); setTypeNotify('error'); handleNotify(); }
        setSavingDlvdRef(false);
    };

    const onImgUploadSuccess = (imgPath) => {
        const fullUrl = `${configApi.URL_API}File/${imgPath}`;
        if (imgUploadType === 'PUP') setLocalPupImg(fullUrl);
        else setLocalDlvdImg(fullUrl);
        setNotifyMessage('อัปโหลดรูปสำเร็จ'); setTypeNotify('success'); handleNotify();
        setImgUploadOpen(false);
    };

    const copyCoords = (text, key) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopiedKey(key);
            setTimeout(() => setCopiedKey(null), 1500);
        });
    };

    const fetchAddress = async () => {
        if (!props.deliveryId) { setAddressData([]); setBranchInfo(null); return; }
        setLoadingAddress(true);
        const [custRes, locRes] = await Promise.allSettled([
            getCustomerAddressByDeliveryID({ Delivery_ID: props.deliveryId }),
            props.currentLocation ? getLocationDetail({ loc: props.currentLocation }) : Promise.resolve(null),
        ]);
        if (custRes.status === 'fulfilled') {
            const r = custRes.value;
            if (r?.code !== 401) setAddressData(r?.data?.content ?? []);
        }
        if (locRes.status === 'fulfilled' && locRes.value) {
            const content = locRes.value?.data?.content;
            const items = Array.isArray(content) ? content : (content ? [content] : []);
            setBranchInfo(items.find(i => i.location_Code === props.currentLocation) ?? items[0] ?? null);
        }
        setLoadingAddress(false);
    };

    const iconstyle = (data, idex, order_status) => {
        if (order_status === "NEW") return { fontSize: "40px", cursor: "not-allowed" };
        if (isGrabOrder && !canGrabCancel) return { fontSize: "40px", cursor: "not-allowed" };
        return { fontSize: "40px", cursor: _isStepClickable(idex) ? "pointer" : "not-allowed" };
    }

    return (
        <div>
            {/* <div style={{ display: loadingPageFlag === 1 ? 'block' : 'none' }}   >
                    <LoadingPage />
                </div> */}
            {loadingPageFlag == 1 ? (
                <div style={{ display: "block" }}>
                    <LoadingPage />
                </div>
            ) : loadingPageFlag == 0 ? (
                <div></div>
            ) : (
                <Dialog
                    open={display.isDisplay}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth="lg" //'xs' | 'sm' | 'md' | 'lg' | 'xl' | false | string
                    fullWidth={true}
                >
                    <DialogTitle className="border-b-2">{"อัปเดทสถานะ"}</DialogTitle>
                    <DialogContent className="m-4">
                        <Typography gutterBottom>
                            <div className="pl-10 pr-10  justify-center items-center">
                                <div className="mb-5 mt-5 flex justify-center items-center ">
                                    <div className="border rounded-md pt-5 pb-5 shadow-inner w-3/4">
                                        {/* <Button variant="text" className='' size="small" style={{ textTransform: "none" }} startIcon={<FaEdit />}
                    size="small"
                    onClick={(event) => onStatusModalClick(row["orderNo"])}
                    disabled={row["serviceStatusCode"] != 'POD' && row["serviceStatusCode"] != 'DDROP' && row["serviceStatusCode"] != 'REJ' ? false : true}
                  >
                  </Button> */}

                                        {/* slip manage */}
                                        {/* <div className="flex justify-end items-center">
                  <div className="pl-2 pr-2 w-1/6 justify-end">
                        {" "}
                        {dataOrder?.order_status === "NEW" || dataOrder?.order_status === "PMT" ? (
                           <label
                           className="w-full"
                           onClick={() => {
                            onUpdateSlip(props.orderNo);
                           }}
                         >
                           <label className="underline text-blue-500 cursor-pointer hover:text-blue-700">
                            อัพเดทสลิป
                           </label>
                         </label>
                        ) : (
                          dataOrder?.slip_img !== null ? 
                          <label
                           className="w-full"
                           onClick={() => {
                            onUpdateSlip(props.orderNo);
                           }}
                         >
                           <label className="underline text-blue-500 cursor-pointer hover:text-blue-700">
                            ดูข้อมูลสลิป
                           </label>
                         </label>
                         :null
                        )}
                        {dataOrder?.slip_img && (
                        <img
                          onClick={handleThumbnailClick}
                          style={{
                            maxWidth: "80%",
                            maxHeight: "100%",
                            cursor: "pointer",
                          }}
                          src={dataOrder?.slip_img}
                          alt="OldSlip"
                          className="max-w-xs drop-shadow-xl rounded-lg max-h-fit cursor-pointer "
                        />
                      )}
                      </div>
                    </div>
                    {showFullPreview &&
                      dataOrder?.slip_img !== null && (
                        <div
                          onClick={handleCloseFullPreview}
                          style={{
                            position: "fixed",
                            top: "0",
                            left: "0",
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.8)",
                            zIndex: "999",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={dataOrder?.slip_img}
                            alt="Full preview"
                            style={{
                              maxWidth: "80%",
                              maxHeight: "80%",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      )} */}
                                        <div className="flex justify-center items-center">
                                            <div className="pl-2 pr-2 w-2/6">
                                                <label className="font-bold inline-block w-24">ชื่อลูกค้า :</label>{" "}
                                                <label>{customerName}</label>
                                            </div>
                                            <div className="pl-2 pr-2 w-2/6">
                                                <label className="font-bold">เบอร์โทร :</label>{" "}
                                                <label>{phoneNo}</label>
                                            </div>
                                        </div>
                                        <div className="flex justify-center items-center ">
                                            <div className="pl-2 pr-2 w-2/6">
                                                <label className="font-bold inline-block w-24">เลขที่ :</label>{" "}
                                                <label>{props.orderNo}</label>
                                            </div>
                                            <div className="pl-2 pr-2 w-2/6">
                                                <label className="font-bold">วันที่ใช้บริการ :</label>{" "}
                                                <label>{serviceDate}</label>
                                            </div>
                                        </div>

                                        <div className="flex justify-center items-center ">
                                            <div className="pl-2 pr-2 w-2/6">
                                                {" "}
                                                <label className="font-bold inline-block w-24">สาขา :</label>{" "}
                                                {/* ปุ่มเปลี่ยนสาขาถูกล็อกเมื่อ step "ซักผ้า" (WASH) เริ่มไปแล้วจริง —
                                                    หาด้วย status_code ตรงๆ (ไม่ใช่ index ตายตัว เพราะ delivery order
                                                    มี PUP แทรกไว้ก่อน RCV ทำให้ jobs[1] กลายเป็น RCV ไม่ใช่ WASH)
                                                    และไม่นับ step ที่ถูกยกเลิก/ย้อนกลับแล้ว (deleted_by ไม่ null) */}
                                                {(() => {
                                                    const washJob = dataOrder?.jobs?.find(j => j.status_code === "WASH");
                                                    const isWashLocked = washJob?.status_date != null && !washJob?.deleted_by;
                                                    return isWashLocked ? (
                                                    <label className="">{dataOrder?.location_desc}</label>
                                                ) : (
                                                    <label
                                                        onClick={() => {
                                                            onSwapOrder(props.orderNo);
                                                        }}
                                                    >
                                                        <label className="underline text-blue-500 cursor-pointer hover:text-blue-700">
                                                            {dataOrder?.location_desc}
                                                        </label>
                                                    </label>
                                                    );
                                                })()}
                                                {dataOrder?.remark && (
                                                    <div className="mt-1">
                                                        <label className="font-bold inline-block w-24">หมายเหตุ :</label>{" "}
                                                        <label>{dataOrder?.remark}</label>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="pl-2 pr-2 w-2/6">
                                                {" "}
                                                <label className="font-bold">สถานะ :</label>{" "}
                                                <label>{dataOrder?.order_status_desc}</label>
                                            </div>
                                        </div>
                                    </div>
                                    {( 
                                    isGrabOrder
                                        ? isPaid === "N"
                                        : (
                                            dataOrder?.order_status === "NEW" ||
                                            dataOrder?.order_status === "PMT"
                                        ) ) && (
                                            <div className="w-1/4 justify-end items-center">
                                                {/* slip manage */}
                                                <div className="items-center text-center">
                                                    <div className="pl-8 pr-2 w-full justify-center text-center">
                                                        {" "}
                                                        {(
                                                        isGrabOrder
                                                        ? isPaid === "N"
                                                        : (
                                                            dataOrder?.order_status === "NEW" ||
                                                            dataOrder?.order_status === "PMT"
                                                        ))? (
                                                            <label
                                                                className="w-full"
                                                                onClick={() => {
                                                                    onUpdateSlip(props.orderNo);
                                                                }}
                                                            >
                                                                <label className="underline text-blue-500 cursor-pointer hover:text-blue-700">
                                                                    {dataOrder?.slip_img === null ||  (
                                                                        isGrabOrder
                                                                            ? isPaid === "N"
                                                                            : (
                                                                                dataOrder?.order_status === "NEW" ||
                                                                                dataOrder?.order_status === "PMT"
                                                                            ) )
                                                                        ? "อัพโหลดสลิป"
                                                                        : "แก้ไขสลิป"}
                                                                </label>
                                                            </label>
                                                        ) : dataOrder?.slip_img !== null ? (
                                                            <label
                                                                className="w-full"
                                                                onClick={() => {
                                                                    onUpdateSlip(props.orderNo);
                                                                }}
                                                            >
                                                                <label className="underline text-blue-500 cursor-pointer hover:text-blue-700">
                                                                    ดูข้อมูลสลิป
                                                                </label>
                                                            </label>
                                                        ) : null}
                                                        {dataOrder?.slip_img && (
                                                            <div
                                                                style={{ textAlign: "-webkit-center" }}
                                                                className="text-center"
                                                            >
                                                                <img
                                                                    onClick={handleThumbnailClick}
                                                                    style={{
                                                                        objectFit: "scale-down",
                                                                        maxWidth: "100%",
                                                                        height: "75px",
                                                                        maxHeight: "80px",
                                                                        cursor: "pointer",
                                                                        textAlign: "-webkit-center",
                                                                    }}
                                                                    src={dataOrder?.slip_img}
                                                                    alt="OldSlip"
                                                                    className="drop-shadow-xl rounded-lg max-w-xs cursor-pointer "
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                {showFullPreview && dataOrder?.slip_img !== null && (
                                                    <div
                                                        onClick={handleCloseFullPreview}
                                                        style={{
                                                            position: "fixed",
                                                            top: "0",
                                                            left: "0",
                                                            width: "100%",
                                                            height: "100%",
                                                            backgroundColor: "rgba(0, 0, 0, 0.8)",
                                                            zIndex: "999",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <img
                                                            src={dataOrder?.slip_img}
                                                            alt="Full preview"
                                                            style={{
                                                                maxWidth: "80%",
                                                                maxHeight: "80%",
                                                                cursor: "pointer",
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                </div>

                                <div className="mb-10 mt-10">
                                    <div className="">
                                        <Stepper
                                            activeStep={(() => {
                                                // completed (ทึบ) = step ที่ทำเสร็จแล้ว (กากบาทยกเลิกได้)
                                                // active (เส้นประ) = step ถัดไปที่ยังไม่ทำ
                                                // ใช้ "index ของ step แรกที่ยังไม่เสร็จ" แทนการนับจำนวน step ที่เสร็จ
                                                // เพราะบาง order สถานะไม่เรียงต่อเนื่อง (เช่น DDROP ไม่ถูกบันทึก แต่ DLVD เสร็จแล้ว)
                                                // การนับจำนวนอย่างเดียวจะทำให้ step ที่เสร็จจริงแสดงเป็นเส้นประผิดตำแหน่ง
                                                for (let i = 0; i < steps.length; i++) {
                                                    if (_isAbsentStep(i)) continue;
                                                    if (!_isStepDone(i)) return i;
                                                }
                                                return steps.length;
                                            })()}
                                            alternativeLabel
                                            connector={<ColorlibConnector />}
                                        >
                                            {steps.map((label, idex) => _isAbsentStep(idex) ? null : (
                                                <Step key={label} completed={_isStepDone(idex)}>
                                                    {jobDesc && (() => {
                                                        // ต้องเช็คว่ามี step ถัดไป "อันไหนก็ได้" ที่เสร็จแล้วหรือไม่ ไม่ใช่แค่ step ถัดไปอันแรก
                                                        // เพื่อไม่ให้ปุ่มยกเลิกไปโผล่ที่ step แรกๆ ทั้งที่ step หลังจากนี้เสร็จไปแล้ว
                                                        let hasLaterDone = false;
                                                        for (let k = idex + 1; k < jobDesc.length; k++) {
                                                            if (_isAbsentStep(k)) continue;
                                                            if (_isStepDone(k)) { hasLaterDone = true; break; }
                                                        }
                                                        const nextNotDone = !hasLaterDone;
                                                        return jobDesc[idex]?.status_date !== null &&
                                                        jobDesc[idex]?.deleted_by == null &&
                                                        nextNotDone &&
                                                        (
                                                          isGrabOrder
                                                        ? canGrabCancel   // ถ้า Grab ต้องผ่านเงื่อนไขนี้
                                                        : true 
                                                        ) && (     // ถ้าไม่ใช่ Grab ใช้เงื่อนไขเดิม
                                                            <MdCancel
                                                                className="hover:cursor-pointer"
                                                                style={{
                                                                    position: "absolute",
                                                                    color: "red",
                                                                    top: "0%",
                                                                    left: "65%",
                                                                    fontSize: "15px",
                                                                    zIndex: "2",
                                                                }}
                                                                onClick={() => {
                                                                    setCancelText(label);
                                                                    setCancelStatusCode(jobDesc[idex]?.status_code ?? dataOrder?.order_status);
                                                                    openModal();
                                                                }}
                                                            />
                                                        );
                                                    })()}
                                                    {/* {jobDesc[idex]?.idx > 0 && (jobDesc[idex]?.status_date !== null)
                                                    ? "not-allowed" : jobDesc[idex]?.idx == 0 && jobDesc[idex]?.status_date !== null? "not-allowed" 
                                                    : jobDesc[idex]?.status_date == null && jobDesc[idex - 1]?.status_date !== null ? "pointer" :"not-allowed"}
                                                    */}
                                                    <StepLabel
                                                        icon={idex + 1}
                                                        style={iconstyle(
                                                            jobDesc,
                                                            idex,
                                                            dataOrder.order_status
                                                        )}
                                                        StepIconComponent={ColorlibStepIcon}
                                                        onClick={(e) => {
                                                            if (dataOrder.order_status === "NEW") return;
                                                            if (isGrabOrder && idex === 0) return;
                                                            if (_isStepClickable(idex)) onEditStatus(props.orderNo, jobDesc[idex]);
                                                        }}
                                                    >
                                                        {label}
                                                        <div className="clear-both"></div>
                                                        {jobDesc[idex]?.deleted_by == null && jobDesc[idex]?.status_date}
                                                        <div className="clear-both"></div>
                                                        {jobDesc[idex]?.deleted_by == null && jobDesc[idex]?.machine_select}
                                                        <div className="clear-both"></div>
                                                        {jobDesc[idex]?.deleted_by == null && jobDesc[idex]?.pic}
                                                    </StepLabel>
                                                </Step>
                                            ))}
                                        </Stepper>


                                        {/* ── บันทึกการเปลี่ยนสาขา (CHG-L) ── */}
                                        {chgLLogs.length > 0 && (
                                            <div className='px-4 mt-6 mb-2'>
                                                <div className='text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2'>
                                                    บันทึกการเปลี่ยนสาขา
                                                </div>
                                                {chgLLogs.map((j, i) => (
                                                    <div key={i} className='rounded-lg border border-amber-200 bg-amber-50 p-3 mb-2 flex gap-3 items-start'>
                                                        <MdLocationOn size={18} className='mt-0.5 flex-shrink-0' style={{ color: "#b45309" }} />
                                                        <div className='flex-1'>
                                                            {j.remark && (
                                                                <div className='text-sm text-amber-900 font-medium'>{j.remark}</div>
                                                            )}
                                                            <div className='flex gap-3 mt-0.5'>
                                                                {j.status_date && (
                                                                    <span className='text-xs text-gray-500'>{j.status_date}</span>
                                                                )}
                                                                {j.created_by && (
                                                                    <span className='text-xs text-gray-400'>โดย {j.created_by}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        {/* ── ข้อมูลไรเดอร์ ── */}
                                        {/* ponytail: แสดงเสมอสำหรับ delivery order (เดิม gate ด้วย Grab URL ที่มีอยู่แล้ว
                                            ทำให้ order ที่ยังไม่มี Grab URL ใส่ลิงก์/อัปรูปไม่ได้ — bug LU delivery) */}
                                        {props.deliveryId && (
                                            <div className="mt-5 rounded-xl border border-gray-200 p-3" style={{ backgroundColor: '#f8fafc' }}>
                                                <p className="text-xs font-semibold text-gray-600 mb-3">ข้อมูลไรเดอร์</p>
                                                {/* รูปภาพ */}
                                                <div className="flex gap-4 flex-wrap mb-3">
                                                    {localOrderImg && (
                                                        <div className="text-center">
                                                            <div className="text-xs text-gray-500 mb-1">รูปสั่งซัก</div>
                                                            <img src={toImgSrc(localOrderImg)} alt="order"
                                                                onClick={() => setPreviewImg(toImgSrc(localOrderImg))}
                                                                style={{ maxHeight: 130, maxWidth: 160, borderRadius: 8, border: '1px solid #e5e7eb', objectFit: 'cover', cursor: 'zoom-in', display: 'block' }} />
                                                        </div>
                                                    )}
                                                    <div className="text-center">
                                                        <div className="text-xs text-gray-500 mb-1">รูปไรเดอร์รับผ้า</div>
                                                        {localPupImg && (
                                                            <img src={toImgSrc(localPupImg)} alt="pup"
                                                                onClick={() => setPreviewImg(toImgSrc(localPupImg))}
                                                                style={{ maxHeight: 130, maxWidth: 160, borderRadius: 8, border: '1px solid #e5e7eb', objectFit: 'cover', cursor: 'zoom-in', display: 'block', marginBottom: 4 }} />
                                                        )}
                                                        <Button size="small" variant="outlined"
                                                            onClick={() => { setImgUploadType('PUP'); setImgUploadOpen(true); }}
                                                            style={{ fontSize: 11, padding: '2px 8px', borderStyle: 'dashed', color: '#303F9F', borderColor: '#303F9F' }}>
                                                            {localPupImg ? 'เปลี่ยนรูป' : 'อัปโหลดรูปรับผ้า'}
                                                        </Button>
                                                    </div>
                                                    <div className="text-center">
                                                        <div className="text-xs text-gray-500 mb-1">รูปไรเดอร์ส่งผ้า</div>
                                                        {localDlvdImg && (
                                                            <img src={toImgSrc(localDlvdImg)} alt="dlvd"
                                                                onClick={() => setPreviewImg(toImgSrc(localDlvdImg))}
                                                                style={{ maxHeight: 130, maxWidth: 160, borderRadius: 8, border: '1px solid #e5e7eb', objectFit: 'cover', cursor: 'zoom-in', display: 'block', marginBottom: 4 }} />
                                                        )}
                                                        <Button size="small" variant="outlined"
                                                            onClick={() => { setImgUploadType('DLVD'); setImgUploadOpen(true); }}
                                                            style={{ fontSize: 11, padding: '2px 8px', borderStyle: 'dashed', color: '#303F9F', borderColor: '#303F9F' }}>
                                                            {localDlvdImg ? 'เปลี่ยนรูป' : 'อัปโหลดรูปส่งผ้า'}
                                                        </Button>
                                                    </div>
                                                </div>
                                                {/* ไรเดอร์รับผ้า URL */}
                                                <div style={{ marginBottom: 6, display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                                                    <span style={{ fontSize: 12, color: '#4b5563' }}>ไรเดอร์รับผ้า:</span>
                                                    {editPupRef ? (
                                                        <>
                                                            <TextField size="small" value={editPupRefVal} onChange={e => setEditPupRefVal(e.target.value)}
                                                                placeholder="วางลิงก์ Grab" inputProps={{ style: { fontSize: 12, padding: '4px 8px' } }} style={{ flex: 1, minWidth: 220 }} />
                                                            <Button size="small" variant="contained" disabled={savingPupRef || !editPupRefVal.trim()} onClick={savePupRef}>
                                                                {savingPupRef ? '...' : 'บันทึก'}
                                                            </Button>
                                                            <IconButton size="small" onClick={() => setEditPupRef(false)}><CloseIcon fontSize="small" /></IconButton>
                                                        </>
                                                    ) : localPickupRef ? (
                                                        <>
                                                            <a href={localPickupRef} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#15803d', textDecoration: 'underline' }}>ติดตาม ↗</a>
                                                            <IconButton size="small" onClick={() => { setEditPupRef(true); setEditPupRefVal(localPickupRef); }}><MdEdit size={14} /></IconButton>
                                                        </>
                                                    ) : (
                                                        <Button size="small" variant="outlined" onClick={() => { setEditPupRef(true); setEditPupRefVal(''); }}
                                                            style={{ fontSize: 11, padding: '2px 8px', borderStyle: 'dashed', color: '#303F9F', borderColor: '#303F9F' }}>
                                                            + ใส่ลิงก์
                                                        </Button>
                                                    )}
                                                </div>
                                                {/* ไรเดอร์ส่งผ้า URL */}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                                                    <span style={{ fontSize: 12, color: '#4b5563' }}>ไรเดอร์ส่งผ้า:</span>
                                                    {editDlvdRef ? (
                                                        <>
                                                            <TextField size="small" value={editDlvdRefVal} onChange={e => setEditDlvdRefVal(e.target.value)}
                                                                placeholder="วางลิงก์ Grab" inputProps={{ style: { fontSize: 12, padding: '4px 8px' } }} style={{ flex: 1, minWidth: 220 }} />
                                                            <Button size="small" variant="contained" disabled={savingDlvdRef || !editDlvdRefVal.trim()} onClick={saveDlvdRef}>
                                                                {savingDlvdRef ? '...' : 'บันทึก'}
                                                            </Button>
                                                            <IconButton size="small" onClick={() => setEditDlvdRef(false)}><CloseIcon fontSize="small" /></IconButton>
                                                        </>
                                                    ) : localDeliveryRef ? (
                                                        <>
                                                            <a href={localDeliveryRef} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#15803d', textDecoration: 'underline' }}>ติดตาม ↗</a>
                                                            <IconButton size="small" onClick={() => { setEditDlvdRef(true); setEditDlvdRefVal(localDeliveryRef); }}><MdEdit size={14} /></IconButton>
                                                        </>
                                                    ) : (
                                                        <Button size="small" variant="outlined" onClick={() => { setEditDlvdRef(true); setEditDlvdRefVal(''); }}
                                                            style={{ fontSize: 11, padding: '2px 8px', borderStyle: 'dashed', color: '#303F9F', borderColor: '#303F9F' }}>
                                                            + ใส่ลิงก์
                                                        </Button>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {/* ── ที่อยู่จัดส่ง + สาขาปัจจุบัน ── */}
                                        {props.deliveryId && (
                                            <div className='mt-6'>
                                                <div className="flex items-center gap-3 mb-4">
                                                    <div style={{ flex: 1, height: 1, backgroundColor: "#d1d5db" }} />
                                                    <span className="flex items-center gap-1.5 text-sm font-semibold" style={{ color: "#111827" }}>
                                                        <MdLocationOn size={15} style={{ color: "#303F9F" }} />
                                                        ที่อยู่จัดส่ง
                                                    </span>
                                                    <div style={{ flex: 1, height: 1, backgroundColor: "#d1d5db" }} />
                                                </div>
                                                {loadingAddress ? (
                                                    <div className="flex justify-center py-6">
                                                        <div className="animate-spin rounded-full h-7 w-7 border-2 border-gray-300"
                                                            style={{ borderTopColor: "#303F9F" }} />
                                                    </div>
                                                ) : (
                                                    /* items-stretch (default) ทำให้ทั้ง 2 column สูงเท่ากัน */
                                                    <div className="grid gap-3" style={{ gridTemplateColumns: '1fr 1fr', alignItems: 'stretch' }}>

                                                        {/* ── ซ้าย: ที่อยู่ลูกค้า ── */}
                                                        <div className="flex flex-col">
                                                            <p className="text-xs font-semibold text-gray-600 mb-2">ที่อยู่ลูกค้า</p>
                                                            {addressData.length === 0 ? (
                                                                <div className="flex-1 rounded-xl border border-dashed border-gray-300 py-5 text-center text-sm text-gray-500">
                                                                    ไม่พบข้อมูลที่อยู่จัดส่ง
                                                                </div>
                                                            ) : addressData.map((addr, idx) => (
                                                                <div key={idx} className="rounded-xl border border-gray-200 p-3 mb-2 last:mb-0 last:flex-1"
                                                                    style={{ backgroundColor: "#f1f5f9" }}>
                                                                    <div className="font-semibold text-gray-900 text-sm leading-tight">{addr.name}</div>
                                                                    <div className="text-gray-600 text-xs mt-0.5 mb-2">{addr.mobile_No}</div>
                                                                    <div className="text-gray-700 text-xs leading-relaxed mb-2">
                                                                        <div>{addr.address}</div>
                                                                        <div>{addr.tambon} {addr.amphure}</div>
                                                                        <div>{addr.province} {addr.zipcode}</div>
                                                                    </div>
                                                                    {addr.latitude && addr.longitude && (
                                                                        <>
                                                                            <div className="flex items-center gap-1 mb-2"
                                                                                style={{ fontSize: 11, color: '#6b7280', fontFamily: 'monospace' }}>
                                                                                <MdLocationOn size={11} style={{ color: '#6b7280', flexShrink: 0 }} />
                                                                                {addr.latitude}, {addr.longitude}
                                                                            </div>
                                                                            <div className="flex flex-wrap gap-1.5">
                                                                                <button onClick={() => copyCoords(`${addr.latitude},${addr.longitude}`, `cust-${idx}`)}
                                                                                    className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-md border border-gray-300 bg-white transition-colors"
                                                                                    style={{ color: "#374151" }}
                                                                                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                                                                    onMouseLeave={e => e.currentTarget.style.backgroundColor = '#ffffff'}>
                                                                                    <MdContentCopy size={12} />
                                                                                    {copiedKey === `cust-${idx}` ? "คัดลอกแล้ว ✓" : "Copy"}
                                                                                </button>
                                                                                <a href={`https://www.google.com/maps?q=${addr.latitude},${addr.longitude}`}
                                                                                    target="_blank" rel="noreferrer"
                                                                                    className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-md text-white transition-opacity"
                                                                                    style={{ backgroundColor: "#303F9F" }}
                                                                                    onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
                                                                                    onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
                                                                                    <MdLocationOn size={12} />
                                                                                    แผนที่
                                                                                </a>
                                                                                {branchInfo?.lat_Long && (
                                                                                    <a href={`https://www.google.com/maps/dir/${branchInfo.lat_Long}/${addr.latitude},${addr.longitude}`}
                                                                                        target="_blank" rel="noreferrer"
                                                                                        className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-md text-white transition-opacity"
                                                                                        style={{ backgroundColor: "#C2410C" }}
                                                                                        onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
                                                                                        onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
                                                                                        <MdDirections size={12} />
                                                                                        จุดรับ→สาขา
                                                                                    </a>
                                                                                )}
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>

                                                        {/* ── ขวา: สาขาปัจจุบัน ── */}
                                                        <div className="flex flex-col">
                                                            <p className="text-xs font-semibold text-gray-600 mb-2">สาขาปัจจุบัน</p>
                                                            {props.currentLocation && (() => {
                                                                const isGreen = props.branchAvailable;
                                                                const borderColor = isGreen === true ? "#86efac" : isGreen === false ? "#fca5a5" : "#d1d5db";
                                                                const bgColor     = isGreen === true ? "#f0fdf4" : isGreen === false ? "#fff1f2" : "#f1f5f9";
                                                                const codeColor   = isGreen === true
                                                                    ? { color: "#166534", backgroundColor: "#bbf7d0" }
                                                                    : isGreen === false
                                                                        ? { color: "#991b1b", backgroundColor: "#fecaca" }
                                                                        : { color: "#1f2937", backgroundColor: "#e5e7eb" };
                                                                const mapColor    = isGreen === true ? "#15803d" : isGreen === false ? "#b91c1c" : "#374151";
                                                                return (
                                                                    <div className="flex-1 rounded-xl border p-3" style={{ borderColor, backgroundColor: bgColor }}>
                                                                        <span className="inline-block font-bold text-sm px-2 py-0.5 rounded-md mb-2" style={codeColor}>
                                                                            {props.currentLocation}
                                                                        </span>
                                                                        {isGreen !== null && isGreen !== undefined && (
                                                                            <div className="mb-3">
                                                                                <span className="text-xs font-semibold px-2 py-0.5 rounded-full" style={{
                                                                                    ...(isGreen
                                                                                        ? { backgroundColor: "#dcfce7", color: "#166534", border: "1px solid #86efac" }
                                                                                        : { backgroundColor: "#fee2e2", color: "#991b1b", border: "1px solid #fca5a5" }
                                                                                    ),
                                                                                }}>
                                                                                    {isGreen ? "✓ พร้อมวันนี้" : "✕ ไม่พร้อมวันนี้"}
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                        {branchInfo?.location_Thai_Name && (
                                                                            <div className="text-gray-900 text-sm font-semibold leading-tight">{branchInfo.location_Thai_Name}</div>
                                                                        )}
                                                                        {branchInfo?.address && (
                                                                            <div className="text-gray-600 text-xs mt-1 leading-relaxed">{branchInfo.address}</div>
                                                                        )}
                                                                        {branchInfo?.location_Eng_Name && (
                                                                            <div className="text-gray-500 text-xs mt-0.5">{branchInfo.location_Eng_Name}</div>
                                                                        )}
                                                                        {branchInfo?.lat_Long && (
                                                                            <>
                                                                                <div className="flex items-center gap-1 mt-2 mb-2"
                                                                                    style={{ fontSize: 11, color: '#6b7280', fontFamily: 'monospace' }}>
                                                                                    <MdLocationOn size={11} style={{ color: '#6b7280', flexShrink: 0 }} />
                                                                                    {branchInfo.lat_Long}
                                                                                </div>
                                                                                <div className="flex flex-wrap gap-1.5">
                                                                                    <button onClick={() => copyCoords(branchInfo.lat_Long, 'branch')}
                                                                                        className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-md border bg-white transition-colors"
                                                                                        style={{ color: "#374151", borderColor: "#d1d5db" }}
                                                                                        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                                                                        onMouseLeave={e => e.currentTarget.style.backgroundColor = '#ffffff'}>
                                                                                        <MdContentCopy size={12} />
                                                                                        {copiedKey === 'branch' ? "คัดลอกแล้ว ✓" : "Copy"}
                                                                                    </button>
                                                                                    <a href={`https://www.google.com/maps?q=${branchInfo.lat_Long}`}
                                                                                        target="_blank" rel="noreferrer"
                                                                                        className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-md text-white transition-opacity"
                                                                                        style={{ backgroundColor: mapColor }}
                                                                                        onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
                                                                                        onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
                                                                                        <MdLocationOn size={12} />
                                                                                        แผนที่
                                                                                    </a>
                                                                                    {(() => {
                                                                                        const firstCust = addressData.find(a => a.latitude && a.longitude);
                                                                                        if (!firstCust) return null;
                                                                                        return (
                                                                                            <a href={`https://www.google.com/maps/dir/${branchInfo.lat_Long}/${firstCust.latitude},${firstCust.longitude}`}
                                                                                                target="_blank" rel="noreferrer"
                                                                                                className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-md text-white transition-opacity"
                                                                                                style={{ backgroundColor: "#0F9D58" }}
                                                                                                onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
                                                                                                onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
                                                                                                <MdDirections size={12} />
                                                                                                สาขา→จุดส่ง
                                                                                            </a>
                                                                                        );
                                                                                    })()}
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        <Modal
                                            open={isModalOpen}
                                            onClose={closeModal}
                                            aria-labelledby="modal-title"
                                            aria-describedby="modal-description"
                                        >
                                            <Box
                                                sx={boxStyle}
                                            >
                                                <h2 className="mb-2" id="modal-title">
                                                    ยกเลิกงาน{cancelText}
                                                </h2>
                                                <TextField
                                                    id="modal-description"
                                                    label="หมายเหตุ"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={remark}
                                                    onChange={handleRemarkChange}
                                                    multiline
                                                    rows={4}
                                                    error={error}
                                                    helperText={errorMessage}
                                                    sx={{ mb: 2 }}
                                                />
                                                <Box display="flex" justifyContent="flex-end">
                                                    <Button variant='contained' color='error' onClick={closeModal} sx={{ mr: 1 }}>
                                                        Cancel
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleSubmit}
                                                        disabled={error}
                                                    >
                                                        Submit
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Modal>
                                    </div>
                                </div>
                            </div>
                        </Typography>

                        <EditStatusOrderModal
                            isDisplay={isEditStatusModal}
                            jobcd={jobDesc ? jobDesc : ""}
                            orderNo={props.orderNo}
                            orderDetail={orderDetail}
                            onClose={() => {
                                setEditStatusModal(false);
                            }}
                            onSuccess={() => {
                                onSearchTracking();
                                setEditStatusModal(false);
                                props.onSuccess?.();
                            }}
                        />

                        <SwapOrderBranchModal
                            isDisplay={isSwapOrderBranch}
                            passSearchPossummary={props.passSearchPossummary}
                            jobcd={jobDesc ? jobDesc : ""}
                            dataOrder={dataOrder}
                            orderNo={props.orderNo}
                            orderDetail={orderDetail}
                            supportOptions={props.supportOptions ?? []}
                            onClose={() => {
                                setSwapOrderBranch(false);
                            }}
                            onSuccess={() => {
                                onSearchTracking();
                                setSwapOrderBranch(false);
                                // handleClose();
                            }}
                        />

                        <UpdateSlipModal
                            isDisplay={isUpdateSlipModal}
                            passSearchPossummary={props.passSearchPossummary}
                            jobcd={jobDesc ? jobDesc : ""}
                            dataOrder={dataOrder}
                            canGrabUpload = {canGrabUpload}
                            orderNo={props.orderNo}
                            isGrabOrder={isGrabOrder}
                            orderDetail={orderDetail}
                            onClose={() => {
                                setUpdateSlipModal(false);
                            }}
                            onSuccess={() => {
                                onSearchTracking();
                                setUpdateSlipModal(false);
                                // handleClose();
                            }}
                        />
                    </DialogContent>
                    <DialogActions className="border-t-2">
                        <Button variant="contained" color="error" onClick={handleClose}>
                            Cancel
                        </Button>
                        {/* <Button variant="contained" color='primary' disabled={btnSubmit} onClick={(event) => onSubmit(event)} autoFocus>
          Submit
      </Button> */}
                    </DialogActions>
                </Dialog>
            )}

            <Snackbar
                open={openNotify}
                autoHideDuration={6000}
                onClose={handleCloseDialog}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                key={"top" + "center"}
            >
                <Alert
                    onClose={handleCloseDialog}
                    severity={typeNotify}
                    sx={{ width: "100%" }}
                >
                    {notifyMessage}
                </Alert>
            </Snackbar>

            <OrderImgUploadModal
                open={imgUploadOpen}
                onClose={() => setImgUploadOpen(false)}
                serviceNo={props.orderNo}
                stepContext={imgUploadType}
                grabUrl={imgUploadType === 'PUP' ? localPickupRef : localDeliveryRef}
                onSuccess={onImgUploadSuccess}
            />

            {/* ── Image preview fullscreen ── */}
            <Dialog open={!!previewImg} onClose={() => setPreviewImg(null)} maxWidth="md">
                <img src={previewImg} alt="preview"
                    onClick={() => setPreviewImg(null)}
                    style={{ display: 'block', maxWidth: '90vw', maxHeight: '90vh', cursor: 'zoom-out' }} />
            </Dialog>
        </div>
    );

}

export default StatusOrderModal;